@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.analytics

data class AnalyticsConfigDto(
    val isEnabled: Boolean,
    val host: String,
    val projectApiKey: String,
    val defaultsDate: String?,
    val isAutocaptureEnabled: Boolean,
    val isPageViewCaptured: Boolean,
    val isPageLeaveCaptured: Boolean,
    val isSessionRecordingEnabled: Boolean,
    val isSurveysEnabled: Boolean,
    val isDebugEnabled: Boolean,
)
